import React, { useEffect } from 'react';

import { Formik } from 'formik';
import { connect } from 'react-redux';

import EnhancedForm1 from './EnhancedForm1';
import ScreenWrapper from '../../components/ScreenWrapper';

import validate from './validations';
import initialValues from './initialValues';

import { PAGES } from '../../config/constants';

const ConsoleBrok = ({ setValues }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <h1
        style={{
          textAlign: 'center',
          fontSize: '60px',
          fontStyle: 'normal',
          fontWeight: 600,
          marginTop: -10,
          marginBottom: 30,
        }}
      >
        A few property questions re your Loan
      </h1>

      <ScreenWrapper fullWidth step={7}>
        <Formik
          initialValues={initialValues()}
          onSubmit={values => {
            setValues(values);
          }}
          validate={validate}
        >
          {formikProps => <EnhancedForm1 {...formikProps} />}
        </Formik>
      </ScreenWrapper>
    </React.Fragment>
  );
};

const mapDispatch = dispatch => {
  return {
    setValues: values => {
      dispatch({
        type: 'SET_CONSOLE_BROK1',
        payload: values,
      });

      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.CONSOLE_BROOK_2,
      });
    },
  };
};

export default connect(null, mapDispatch)(ConsoleBrok);



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/index.js